import Table from "components/Table";
import { useMemo, useEffect } from "react";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import UnitsHistoryReportFilter from "./UnitsHistoryReportFilter";

const neededDomains = ["Category", "Is_Removed", "Is_Installed", "Location"];

export default function UnitsHistoryReport() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();
  const { view, unitsHistoryTable, unitsHistory } = map;

  const headers = useMemo(
    () => [
      {
        accessorKey: "Unit_Prod_ID",
        header: "Unit ID",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Pallet_ID",
        header: "Palette ID",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Category",
        header: "Category",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.CategoryName,
      },
      {
        accessorKey: "Stage",
        header: "Stage",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Location",
        header: "Location",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Is_Removed",
        header: "Is Removed from Palette",
        cell: (param) => param.cell.row.original.Is_RemovedName,
        enableColumnFilter: false,
      },
      {
        accessorKey: "Is_Installed",
        header: "Status",
        cell: (param) => param.cell.row.original.Is_InstalledName,
        enableColumnFilter: false,
      },
      {
        accessorKey: "created_date",
        header: "Date",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.created_date_ISO,
      },
    ],
    []
  );

  const exportHeaders = useMemo(
    () => [
      {
        key: "Unit_Prod_ID",
        label: "Unit ID",
      },
      {
        key: "Pallet_ID",
        label: "Palette ID",
      },
      {
        key: "CategoryName",
        label: "Category",
      },
      {
        key: "Stage",
        label: "Stage",
      },
      {
        key: "Location",
        label: "Location",
      },
      {
        // key: "Is_Removed",
        key: "Is_RemovedName",
        label: "Is Removed from Palette",
      },
      {
        key: "Is_InstalledName",
        label: "Status",
      },
      {
        key: "created_date_ISO",
        label: "Date",
      },
    ],
    []
  );

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        const orderByFields = ["created_date DESC"];

        if (unitsHistoryTable && view && token) {
          const {
            res: unitsHistoryRes,
            domains: unitsHistoryDomains,
            fields: unitsHistoryFields,
          } = await getEsriDataFromLayer({
            featureLayer: unitsHistoryTable,
            orderByFields,
            neededDomains,
          });

          console.log(unitsHistoryRes);

          dispatchMap({
            type: "INIT",
            payload: {
              unitsHistoryDomains,
              unitsHistoryFields,
              unitsHistory: unitsHistoryRes,
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, unitsHistoryTable]);

  return (
    <div>
      <UnitsHistoryReportFilter />
      <Table
        columns={headers}
        data={unitsHistory}
        exportName={`Units-History-Report-${
          new Date().toISOString().split("T")[0]
        }`}
        exportColumns={exportHeaders}
      />
    </div>
  );
}
